import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, from } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Injectable()
export class EmployeeProxyInterceptor implements HttpInterceptor {

    public intercept(
        request: HttpRequest<any>,
        handler: HttpHandler
    ): Observable<HttpEvent<any>> {
        return handler.handle(request)
            .pipe(
                catchError((error: HttpErrorResponse) => this.handleApiError(error))
            );
    }

    private handleApiError(error: HttpErrorResponse): Observable<any> {

        if(!environment.employeeSite)
        {
            // If we are not on the employee site, we don't need this logic, so rethrow.
            return throwError(error);
        }

        if (error.status && error.status != 504) {
            // If we have a status code, then this is not the sort of proxy redirect CORS error we care about.
            // Exception is that 504 (gateway timeouts) should be treated as non-status code errors,
            // as the serviceworker returns that status code for cors errors.
            return throwError(error);
        }


            var test = async() => {
                try{

                    let result = await fetch(`/config.json?ngsw-bypass=true&cache-buster=${Date.now()}`, {redirect: "manual"});
                    if (result.type == "opaqueredirect")
                    {
                        // we are on employee site, and we get a redirect
                        // this means the proxy has timed out, so we need to
                        // somehow refresh the page bypassing the service worker.
                        window.location.href=`/?ngsw-bypass=true&cache-buster=${Date.now()}`
                    }
                }
                catch (e)
                {
                }

                throw error;

            };
            return from(test());


    }
}
